import { render, staticRenderFns } from "./PaymentsTable.vue?vue&type=template&id=451e4dc4&scoped=true&"
import script from "./PaymentsTable.vue?vue&type=script&lang=js&"
export * from "./PaymentsTable.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsTable.vue?vue&type=style&index=0&id=451e4dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451e4dc4",
  null
  
)

component.options.__file = "PaymentsTable.vue"
export default component.exports